import {ExtraData} from '@deliveriesondemand/dod-data';
import {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import handlers from 'react-handlers';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import ApiService from '-/services/ApiService';
import NavigationService from '-/services/NavigationService';
import AccessoryMultiSelect from '-/components/fields/AccessoryMultiSelect';
import {Control, ControlGroup} from '-/components/fields/Control';
import TextInput from '-/components/fields/TextInput';
import Select from '-/components/fields/Select';
import Address from '-/components/general/Address';
import PhoneInput from '-/components/fields/PhoneInput';
import {NumberInput} from '-/components/fields/NumberInput';
import DateInput from '-/components/fields/DateInput';
import {saveDoc} from '-/api/api';
import StipsService from '-/services/StipsService';
import ToastService from '-/services/ToastService';
import StepButtons from '-/components/general/StepButtons';
import Button from '-/components/general/Button';
import Form from '-/components/fields/Form';
import {renderError} from '-/util/error';
import {
    getVinVehicleInfo,
    renderFieldErrors,
    getIsolatedStipType,
    isMobile,
    getOfferId
} from '-/util/util';
import Vin from '-/components/fields/vehicle/Vin';
import Trim from '-/components/fields/vehicle/Trim';
import CreditorService from '-/services/CreditorService';
import {get, isFinite, set} from '-/util/lodash';
import {RadioGroup, Radio} from '-/components/fields/RadioGroup';
import Legend from '-/components/fields/Legend';
import VehicleInfoService from '-/services/VehicleInfoService';

const styles = () => ({
    topMargin: {
        marginTop: 10
    }
});

class StipEdit extends Component {
    constructor(props) {
        super(props);

        const {
            name = '',
            address = '',
            mileage = 0,
            relationship = '',
            phone = '',
            vehicle = {}
        } = props.doc.extra || {};
        const checkPickupLocation = get(props, 'doc.extra.checkPickup.address.name', '');

        this.state = {
            accessories: [],
            bookoutApproved: false,
            bookoutDownloaded: false,
            checkPickupLocation,
            name,
            address,
            mileage,
            relationship,
            phone,
            vehicle,
            errorMessages: [],
            showErrors: false,
            ucgVehicleId: '',
            vin: '',
            vinFeedbackMsg: '',
            vinTrims: []
        };
    }

    handleCheckPickupLocationChange = value => {
        this.handleFieldChange('checkPickupLocation', value);
    };

    handleNameChange = value => {
        this.handleFieldChange('name', value);
    };

    handleAddressChange = value => {
        this.handleFieldChange('address', value);
    };

    handlePhoneChange = value => {
        this.handleFieldChange('phone', value);
    };

    handleRelationshipChange = value => {
        this.handleFieldChange('relationship', value);
    };

    handleMileageChange = value => {
        VehicleInfoService.set('mileage', value);
        // TODO: This is really a hack to get things back to the way things were
        // There's still a weird differentiation between how mileage is handled for stips submission and as part of the app submission wrap up
        // They should either be unified, or split apart...currently this is unholy alliance
        this.handleFieldChange('mileage', value);
    };

    handleNextPaymentDateChange = value => {
        this.handleFieldChange('nextPaymentDate', value);
    };

    handleFieldChange(name, value) {
        this.setState({[name]: value});
    }

    getStateValue(key, owner) {
        const {state} = this;

        if (owner) {
            const collection = state[owner] || {};
            return collection[key];
        }

        return state[key];
    }

    handleSaveClick = () => {
        this.onClickIfValid(() => {
            const {
                stip,
                indexOfDoc,
                applicantType,
                offerId,
                requireBookoutConfirmation,
                stipType,
                vehicleInfo = {}
            } = this.props;
            let {doc} = this.props;
            const {bookoutApproved, mileage} = this.state;
            const source = ExtraData[stipType];
            const {owner} = source;
            const includeBookoutApproval = stipType === 'EXM' && requireBookoutConfirmation;
            const isVin = stipType === 'VIN';
            const extraData = {
                ...includeBookoutApproval && {
                    bookoutApproval: {
                        bookoutApproved: bookoutApproved === 'yes',
                        mileage,
                        requireBookoutConfirmation
                    }
                }
            };

            const vinVehicleInfo = getVinVehicleInfo(vehicleInfo);

            if (vinVehicleInfo) {
                set(vehicleInfo, 'vinVehicleInfo', vinVehicleInfo);
            }

            Object.keys(source.fields).forEach(key => {
                const dataKey = owner ? `${owner}.${key}` : key;
                const value = isVin ? vehicleInfo[key] : this.getStateValue(key, owner);
                set(extraData, dataKey, value);
            });

            doc = {
                ...doc,
                extra: extraData
            };

            const {status} = doc;
            const isolatedStipType = getIsolatedStipType();

            saveDoc({
                _id: offerId,
                stipType,
                applicantType,
                indexOfDoc,
                isolatedStipType
            }, doc).then(({data:{doc}}) => {
                StipsService.setRef(stip, {
                    ...doc,
                    status,
                    changed: true
                });

                NavigationService.goBack();
            }).catch(err => {
                ToastService.addToastWithDuration(ToastService.DANGER, 5000, renderError(err));
            });
        });
    };

    handleCloseClick = () => {
        const {mileage} = this.state;

        if (isFinite(mileage) && mileage > 0) {
            const cancel = !confirm('You have entered a mileage without saving. Are you sure you want to cancel?');

            if (cancel) {
                return;
            }
        }
        
        NavigationService.goBack();
    };

    getErrorMessages() {
        const {props, refs} = this;
        const {stipType} = props;
        const {fields} = ExtraData[stipType];

        return Object.keys(fields).reduce((errors, key) => {
            const field = refs[key];

            if (key === 'checkPickupLocation') {
                const {checkPickupLocation} = this.state;

                if (!checkPickupLocation) {
                    errors.push('Please select a check pickup location');
                }
            } else if (field) {
                const {label} = fields[key];
                const fieldErrors = field.getErrors(label);

                if (fieldErrors.length) {
                    errors.push(...fieldErrors);
                }
            }

            return errors;
        }, []);
    }

    onInputChange = () => {
        const {state} = this;
        if (state.showErrors) {
            const errorMessages = this.getErrorMessages();
            this.setState({errorMessages});
        }
    };

    onClickIfValid(fn) {
        const errorMessages = this.getErrorMessages();
        this.setState({errorMessages, showErrors: true});
        if (errorMessages.length <= 0) {
            fn();
        }
    }

    handleFormSubmit = e => {
        e.preventDefault();

        this.handleSaveClick();
    };

    renderCloseButton(disableButton  = false) {
        const closeBtn = <Button btnStyle="previous" onClick={this.handleCloseClick}>Cancel</Button>;
        const saveBtn = <Button disabled={disableButton} onClick={this.handleFormSubmit}>Save</Button>;

        return <StepButtons buttons={[closeBtn, saveBtn]} />;
    }

    renderTitle() {
        const {doc} = this.props;
        return (
            <p className="info">
                <strong>{doc.title}</strong>
            </p>
        );
    }

    renderRefForm() {
        const {name, address, phone, relationship} = this.state;
        return (
            <div>
                <p className="info">References can not live at the same address as applicant.</p>
                <ControlGroup labelWidth={120}>
                    <Control labelsAbove={false}>
                        <TextInput
                            ref="name"
                            value={name}
                            label="Name"
                            onChange={handlers(this.handleNameChange, this.onInputChange)} />
                    </Control>
                    <Address
                        ref="address"
                        value={address}
                        onChange={handlers(this.handleAddressChange, this.onInputChange)} />
                    <Control>
                        <PhoneInput
                            ref="phone"
                            value={phone}
                            label="Phone"
                            onChange={handlers(this.handlePhoneChange, this.onInputChange)} />
                    </Control>
                    <Control>
                        <TextInput
                            ref="relationship"
                            value={relationship}
                            label="Relationship"
                            onChange={handlers(this.handleRelationshipChange, this.onInputChange)} />
                    </Control>
                </ControlGroup>
            </div>
        );
    }

    renderMaidenNameForm() {
        const {name} = this.state;
        return (
            <ControlGroup labelWidth={200}>
                <Control labelsAbove={false}>
                    <TextInput
                        ref="name"
                        value={name}
                        label="Mother's Maiden Name"
                        onChange={handlers(this.handleNameChange, this.onInputChange)} />
                </Control>
            </ControlGroup>
        );
    }

    handleConfirmationChange = e => {
        const bookoutApproved = get(e, 'target.value');

        this.setState({
            bookoutApproved
        });
    };

    handleBookoutButtonClick = async() => {
        const {mileage, offerId} = this.props;

        if (isFinite(mileage) && mileage > 0) {
            await ApiService.save('vehicleInfo');
            const generateUrl = `/api/refi/saveBookout?entityId=${offerId}&entityType=Offer&pdfType=bookout`;

            window.open(generateUrl);

            this.setState({
                bookoutDownloaded: true
            });
        }
    };

    renderCheckPickupLocationForm = () => {
        const {branches, classes} = this.props;
        const {checkPickupLocation} = this.state;
        const branch = branches.find(branch => branch.name === checkPickupLocation);
        const address = get(branch, 'formatted');
        const pClass = classNames('info', classes.topMargin);

        return (
            <ControlGroup labelWidth={120}>
                <Control labelsAbove={false}>
                    <Select ref="checkPickupLocation" label="Location" onChange={handlers(this.handleCheckPickupLocationChange, this.onInputChange)}>
                        <option omitFromList>Please select a check pickup location</option>
                        {branches.map(branch => {
                            const {formatted, name} = branch;

                            return (
                                <option
                                    key={branch}
                                    selected={name === checkPickupLocation}
                                    value={name}>
                                    {name} ({formatted})
                                </option>
                            );
                        })}
                    </Select>
                </Control>
                {address && 
                    <p className={pClass}>Selected Address: {address}</p>
                }
            </ControlGroup>
        );
    };

    renderMileageForm() {
        const {bookoutApproved, mileage} = this.state;
        const {classes, requireBookoutConfirmation} = this.props;
        const pClass = classNames('info', classes.topMargin);

        return (
            <ControlGroup labelWidth={120}>
                <Control labelsAbove={false}>
                    <NumberInput
                        ref="mileage"
                        value={mileage}
                        label="Mileage"
                        onChange={handlers(this.handleMileageChange, this.onInputChange)} />
                </Control>
                {(mileage && requireBookoutConfirmation) && (
                    <Fragment>
                        <p className={pClass}>
                            Now that you&apos;ve added your <b>exact</b> mileage, please
                            click the button below to download your vehicle&apos;s
                            bookout valuation. If it all looks correct, check the box to
                            acknowledge your confirmation of the vehicle information.
                        </p>
                        <Button onClick={this.handleBookoutButtonClick}>Download Bookout</Button>
                        <p className="info">
                            Do the vehicle details* in this document correctly represent
                            your automobile? If so, please select &quot;Yes&quot;. If not,
                            or if your file did not generate properly, please select &quot;No&quot;.
                        </p>
                        <p className={pClass}>
                            <small><i>
                                *Year, make, model, trim, accessories, and mileage.
                            </i></small>
                        </p>
                        <ControlGroup>
                            <Legend>Confirm Bookout?</Legend>
                            <RadioGroup vertical={isMobile()}>
                                <Radio
                                    label="Yes"
                                    name="bookoutApproved"
                                    value="yes"
                                    checked={bookoutApproved === 'yes'}
                                    onChange={this.handleConfirmationChange} />
                                <Radio
                                    label="No"
                                    name="bookoutApproved"
                                    value="no"
                                    checked={bookoutApproved === 'no'}
                                    onChange={this.handleConfirmationChange} />
                            </RadioGroup>
                        </ControlGroup>
                    </Fragment>
                )}
            </ControlGroup>
        );
    }

    renderPaymentDueForm() {
        const {nextPaymentDate} = this.state;
        return (
            <div>
                <p className="info">When is the next payment of your existing car loan due?</p>
                <ControlGroup labelWidth={130}>
                    <Control labelsAbove={false}>
                        <DateInput
                            ref="nextPaymentDate"
                            value={nextPaymentDate}
                            label="Payment Date"
                            onChange={handlers(this.handleNextPaymentDateChange, this.onInputChange)}
                            futureOnly={true} />
                    </Control>
                </ControlGroup>
            </div>
        );
    }

    onVehicleChange = (vehicleObj = {}) => {
        for (const [key, value] of Object.entries(vehicleObj)) {
            VehicleInfoService.set(key, value);
        }
    };

    onVinChange = data => {
        const {trims = [], vehicle = {}} = data;

        VehicleInfoService.setExperianData(data);
        this.onVehicleChange(vehicle);
        this.setState({vinTrims: trims});
    };

    onAccessoryChange = (accessories = []) => {
        VehicleInfoService.setAccessories(accessories);
    };

    render() {
        const {
            buyerName,
            contactPhone,
            mileage,
            requireBookoutConfirmation,
            stipType,
            vehicleInfo = {}
        } = this.props;
        const {
            bookoutApproved,
            bookoutDownloaded,
            errorMessages,
            showErrors,
            vinTrims
        } = this.state;
        const {bookout = {}, style, ucgVehicleId, vin} = vehicleInfo;
        const {accessories = []} = bookout;
        const showAccessories = vin && ucgVehicleId && style;
        const exmReqs = stipType === 'EXM' && requireBookoutConfirmation;
        const exmFieldReqs = !bookoutApproved || !bookoutDownloaded || !mileage;
        const disableButton =  exmReqs && exmFieldReqs;

        return (
            <div className="stip-edit">
                <Form standalone={true} onSubmit={this.handleFormSubmit}>
                    {this.renderTitle()}
                    {stipType === 'CHKLOC' && this.renderCheckPickupLocationForm()}
                    {stipType === 'REF' && this.renderRefForm()}
                    {stipType === 'MMN' && this.renderMaidenNameForm()}
                    {stipType === 'EXM' && this.renderMileageForm()}
                    {stipType === 'PYMT' && this.renderPaymentDueForm()}
                    {stipType === 'VIN' && (
                        <Fragment>
                            <Vin
                                buyerName={buyerName}
                                handleChange={this.onVinChange}
                                includeExperian={true}
                                includeNADA={true}
                                vehicleInfo={vehicleInfo}
                                showErrors={showErrors} />
                            {(vin && vinTrims.length > 0) && (
                                <Trim
                                    contactPhone={contactPhone}
                                    handleChange={this.onVehicleChange}
                                    handleAccessoriesChange={this.onAccessoryChange}
                                    showErrors={showErrors}
                                    vehicleInfo={vehicleInfo}
                                    trims={vinTrims} />
                            )}
                            {showAccessories && (
                                <Fragment>
                                    <p className="info">
                                        If you have any of the features listed below on your
                                        vehicle please select them. If you have any questions
                                        about what a feature means please call {contactPhone}
                                    </p>
                                    <AccessoryMultiSelect
                                        accessoriesSelected={accessories}
                                        ucgVehicleId={Number(ucgVehicleId)}
                                        vin={vin}
                                        handleCheckboxToggle={this.onAccessoryChange} />
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                    {showErrors && renderFieldErrors(errorMessages)}
                </Form>
                {this.renderCloseButton(disableButton)}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {config = {}, navigation, stips, vehicleInfo = {}} = state;
    const {mileage} = vehicleInfo;
    const {contactPhone} = config;
    const {stip, doc} = navigation.currentStepData;
    const buyerName = get(state, 'buyerInfo.buyerInfo.name');
    const indexOfDoc = stip.docs.findIndex(stipDoc => stipDoc._id === doc._id);
    const requireBookoutConfirmation = CreditorService.getRequireBookoutConfirmation();
    const branches = CreditorService.getBranches();
    const {docType: stipType} = stip;

    return {
        applicantType: stips.applicantType,
        branches,
        buyerName,
        contactPhone,
        offerId: getOfferId(),
        indexOfDoc,
        mileage,
        requireBookoutConfirmation,
        stip,
        stipType,
        doc,
        vehicleInfo
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(StipEdit));
